import { render, staticRenderFns } from "./BannersForm.vue?vue&type=template&id=995a8ac4&scoped=true&"
import script from "./BannersForm.vue?vue&type=script&lang=js&"
export * from "./BannersForm.vue?vue&type=script&lang=js&"
import style0 from "./BannersForm.vue?vue&type=style&index=0&id=995a8ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995a8ac4",
  null
  
)

export default component.exports